import { Box } from "@mui/material";
import { FollowersNullSet } from "../components/nullSets/chatNullset";
import { resource } from "../common/resource";
import { useEffect } from "react";
import { inIframe, WEBSITE_PATH } from "../common/common";
import { isMobileOnly } from "react-device-detect";

const StoreQuotationRequests = () => {
  useEffect(() => {
    if (!inIframe()) {
      window.location.href = WEBSITE_PATH;
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Box className={`inboxContentContainerEmpty ${isMobileOnly ? "mar-t-16" : "mar-t-24"}`}>
      <FollowersNullSet header="No quotation requests" body={`${resource.quotationRequest}`} />
    </Box>
  );
};

export default StoreQuotationRequests;
